import ReactDOM from 'react-dom/client';

import { configureAxios } from 'config/axios';

// Use consistent styling
import 'sanitize.css/sanitize.css';
import 'styles/global.css';
import App from 'app';
import { BrowserRouter } from 'react-router-dom';
import { LoadingProvider } from 'contexts/loading';
import { FlashProvider } from 'contexts/flash';
import { UserProvider } from 'contexts/user';
import { Flash } from 'app/components/elements/Flash';
import { ThemeProvider, StyledEngineProvider, CssBaseline } from '@mui/material';
import theme from 'styles/theme';
import { MapProvider } from 'contexts/map';

// Initialize axios
configureAxios();

/**
 * Root App
 */
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LoadingProvider>
          <MapProvider>
            <UserProvider>
              <FlashProvider>
                <CssBaseline />
                <App />
                <Flash />
              </FlashProvider>
            </UserProvider>
          </MapProvider>
        </LoadingProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </BrowserRouter>
);
